export default __webpack_public_path__ + "static/christopher-615ea09db67f52cda7ba12820cd8466f.jpeg";